import { render, staticRenderFns } from "./batchSubmitOrApproveDialog.vue?vue&type=template&id=7629742e&"
import script from "./batchSubmitOrApproveDialog.vue?vue&type=script&lang=js&"
export * from "./batchSubmitOrApproveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7629742e')) {
      api.createRecord('7629742e', component.options)
    } else {
      api.reload('7629742e', component.options)
    }
    module.hot.accept("./batchSubmitOrApproveDialog.vue?vue&type=template&id=7629742e&", function () {
      api.rerender('7629742e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog.vue"
export default component.exports